<template>
  <filter-wrapper>
    <z-form ref="form" @submit.prevent.native="submit">
      <template slot="default">
        <div class="filter__row">
          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('voice.stats.general.filter.group_by.title') }}
            </label>
            <z-form-input
              class="filter__item__body"
              :rules="{ required: true }"
              :show_errors="false"
            >
              <i-select v-model="form.group_by">
                <i-option
                  v-for="(label, key) in $t('voice.stats.general.filter.group_by.values')"
                  :key="key"
                  :value="key"
                  :label="label"
                />
              </i-select>
            </z-form-input>
          </div>

          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('voice.stats.general.filter.voice_stats.trunk.title') }}
            </label>
            <z-form-input
              class="filter__item__body"
              :rules="{ required: true }"
              :show_errors="false"
              mode="aggressive"
            >
              <trunks-input-select-trunk
                v-model="form.trunk_ids"
                :trunks="trunks"
                :general="true"
                :multiple="true"
                @input="selectTrunks"
              />
            </z-form-input>
          </div>

          <div class="filter__item filter__item--datepicker col-6">
            <label class="filter__item__title">
              {{ $t('shared.component.filter.period') }}
            </label>
            <z-form-input class="filter__item__body">
              <date-range-picker v-model="form.date" :clearable="true" />
            </z-form-input>
          </div>
        </div>

        <div class="filter__row">
          <div class="filter__item col-3">
            <label class="filter__item__title">
              {{ $t('voice.stats.general.filter.voice_stats.destination.title') }}
            </label>
            <div class="filter__item__body">
              <country-select v-model="form.country_iso" />
            </div>
          </div>

          <div class="filter__item filter__item--button ml-auto">
            <i-button html-type="submit" type="primary" size="large">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
        </div>
      </template>
    </z-form>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import CountrySelect from './country-select';
  import { mapActions } from 'vuex';
  import { TrunkService } from '@voice/services/TrunkService';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import TrunksInputSelectTrunk from '@voice/components/trunks-input-select-trunk';

  export default {
    components: {
      TrunksInputSelectTrunk,
      FilterWrapper,
      CountrySelect,
    },
    data() {
      return {
        form: {
          trunks: [],
          group_by: 'day',
          trunk_ids: [],
          country_iso: null,
          date: initSearchStateByPeriod()
        }
      };
    },

    mounted() {
      TrunkService.getSelect().then((res) => {
        if (res.length) {
          this.trunks = res;
          this.form.trunk_ids = [res[0].id];
          this.$nextTick(() => {
            this.submit();
          });
        }
      });
    },

    methods: {
      ...mapActions('voice/stats/general', ['search']),

      selectTrunks: function (val) {
        if (val[val.length - 1] === 'all') {
          this.form.trunk_ids = ['all'];
        } else {
          this.form.trunk_ids = val.filter((i) => i !== 'all');
        }
      },

      getTrunkFilterParams: function (ids) {
        if (ids.find((i) => i === 'all')) {
          return null;
        } else if (ids.length > 1) {
          return `bulk:${ids.toString()}`;
        } else if (ids.length === 1) {
          return ids[0];
        }
      },

      submit: function () {
        this.$emit('getGroupBy', this.form.group_by);
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const { start, end } = parseSearchStateByPeriod(this.form.date);
            const { group_by, trunk_ids, country_iso } = this.form;

            const params = {
              group_by: group_by,
              date_from: start,
              date_to: end,
              trunk_id: this.getTrunkFilterParams(trunk_ids),
              country_iso
            };

            this.search(params);
          }
        });
      }
    }
  };
</script>
